import { render, staticRenderFns } from "./ReportMoneyDistributor.vue?vue&type=template&id=72548ae0&"
import script from "./ReportMoneyDistributor.vue?vue&type=script&lang=js&"
export * from "./ReportMoneyDistributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports